import { useTheme } from '@doxyme/ui-foundation/theme';
export const useModalFooterStyles = ({ layout })=>{
    const theme = useTheme();
    return {
        container: {
            display: 'flex',
            padding: theme.spacing(6),
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: theme.spacing(3),
            width: '100%'
        },
        buttonContainer: {
            display: 'flex',
            gap: theme.spacing(4),
            width: '100%'
        },
        buttons: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: layout === 'equal-buttons' ? 'stretch' : 'center',
            gap: theme.spacing(4),
            flex: '1 0 0',
            width: '100%',
            flexDirection: layout === 'equal-buttons' ? 'column' : undefined
        },
        backButton: {
            flexGrow: 0
        },
        caption: {
            textAlign: 'center',
            color: theme.text.generic.tertiary
        }
    };
};

//# sourceMappingURL=modalFooter.styles.js.map